import { SortDirection } from "@redotech/congo-enums/sort-direction";
import { WithdrawalListView } from "@redotech/merchant-sdk/rpc/schema/withdrawals/list-withdrawals";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { keepPreviousData } from "@tanstack/react-query";

export function withdrawalNeedsActionCountQueryKey(teamId: string) {
  return ["withdrawal-needs-action-count", teamId] as const;
}

/** How many withdrawals wait on the merchant, shared by the side nav and the home page. */
export function useWithdrawalNeedsActionCount(): number | undefined {
  const team = useRequiredContext(TeamContext);
  const query = useRpcQuery(RedoMerchantRpcClientContext, {
    method: "listWithdrawals",
    args: {
      view: WithdrawalListView.NEEDS_ACTION,
      pageSize: 1,
      offset: 0,
      sortDirection: SortDirection.Desc,
    },
    options: {
      queryKey: withdrawalNeedsActionCountQueryKey(team._id),
      placeholderData: keepPreviousData,
    },
  });
  return query.data?.total;
}
